<template>
  <div class="chat">
    <div class="fabulous">
      <div class="headImg">
        <img :src="creatUserId.pfPhoto?creatUserId.pfPhoto: that.location.origin+'/cme-sso-app/showimg/642949534757982209'"
            alt="">
        <span v-show="creatUserId.pfName" :title="creatUserId.pfName">{{creatUserId.pfName}}</span>
      </div>
      <div class="fabulous-right" style="display:flex;" @click.stop="">
        <div class="clickFab"
            title="点赞">
          <img @click.prevent="changOption()" :src="parseInt(initData.like)?require('../assets/image/images/fabulous_curr.png'):require('../assets/image/images/fabulous.png')">
          <span class="numbers" @click="changeCenterShow('likes')">{{initData.likeNum}}</span>
        </div>
        <div class="clickFab"
            v-if="shopping || brush==2"
            title="评论">
          <img @click="pinglunChange()" :src="require('../assets/image/images/comment.png')">
          <span class="numbers" @click="changeCenterShow('pinglun')">{{initData.commentNum}}</span>
          <div class="FloatingLayer" v-show="pinglunShow">
            <div class="suspend" title="" @click="reflexs()"><a href="javascript:;">评论</a></div>
            <div class="suspend" title="" @click="dialogues()"><a href="javascript:;">对话</a></div>
          </div>
        </div>
        
        <div class="clickFab"
            v-if="shopping || brush==2"
            title="转发">
          <img @click="forwardShowOrNot()" :src="require('../assets/image/images/forward.png')">
          <span class="numbers" @click="changeCenterShow('forwards')">{{initData.forwards ? initData.forwards.length : 0}}</span>
          <div class="FloatingLayer" v-show="forwardShow">
            <div class="suspend" title="" @click="retransmission(0)"><a href="javascript:;">直接转发</a></div>
            <div class="suspend" title="" @click="retransmission(1)"><a href="javascript:;">重新转发</a></div>
          </div>
        </div>
        <div class="clickFab"
            title="收藏">
          <img @click.prevent="changOptions()" :src="parseInt(initData.collect)?require('../assets/image/images/Collection_curr.png'):require('../assets/image/images/Collection.png')">
          <span class="numbers" @click="changeCenterShow('collects')">{{initData.collectNum}}</span>
        </div>
        <div class="clickFab cart showChoose"
            :cid="contentIds"
            v-if="!shopping && brush==1"
            @click.prevent="repeat('Cart')"
            title="购物车">
          <img :src="require('../assets/image/images/shopping_cart.png')">

        </div>
        <div class="clickFab shopping showChoose"
            :cid="contentIds"
            v-if="!shopping && brush==1"
            @click.prevent="repeat('shopping')"
            title="购买">
          <i />
        </div>
        <div class="clickFab"
            title="下载">
          <img @click="downLoad('',titleCont,ite.contentWzUrl || ite.contentDsfWzUrl,contentIds)" :src="require('../assets/image/images/download_icon.png')">
          <span class="numbers" @click="changeCenterShow('downloads')">{{initData.xzNum}}</span>
        </div>
      </div>
    </div>
    <!-- 评论框 -->
    <div class="comment" @click.stop="" v-if="shopping || brush==2">
      <div :class="['LikePeople',iconType]" v-if="centerShow.length">
        <div :class="{people:isOverThreeLines}" :style="{'-webkit-line-clamp': 4*dznum}" ref="textRef">
          <span v-for="(ite,ind) in centerShow" :key="ind" :title="ite.userName"> <span v-show="ind>0">、</span><span class="name" @click="dialogue(ite)">{{ite.userName}}</span></span>
        </div>
        <div class="moreOrNot" v-show="isOverThreeLines" @click.stop="dzShow()"><span> {{dzHeight > 16*4*dznum ? '更多 ∨' : '收起 ∧'}}</span></div>
      </div>
      <div v-for="(ite,ind) in content"
           :key="ind"
           class="line"
           v-show="ind < 4*plnum && pinglunShow">
        <div class="line-l">
          <span class="name" @click="dialogue(ite)">{{ite.userName}}</span>
          <span v-if="ite.toUserName"
                class="rep">回复</span>
          <span class="name"
                v-if="ite.toUserName" @click="dialogue(ite,'to')">{{ite.toUserName}}</span>
          <span class="content">: {{ite.texts}}</span>
        </div>
        <div class="line-r">
          <div class="delete"
               v-if="((creatUserId && creatUserId == $store.state.userInfo.userId) || (ite.userId && $store.state.userInfo.userId == ite.userId))">
            <div @click="deletes(ite.id)" title="删除">
              <img :src="require('@/assets/image/images/delete.png')">
            </div>
          </div>
          <div class="reply"
               @click="reflexs(ite,ind)" title="评论">
            <img :src="require('@/assets/image/images/comment.png')">
          </div>
        </div>

      </div>
      <div class="pLmoreOrNot" v-show="content&&content.length > 4 && pinglunShow" @click.stop="pLShow()"><span> {{content&&content.length > 4*plnum ? '更多 ∨' : '收起 ∧'}}</span></div>
      <div class="reflex"
           v-show="reflex">
        <textarea name="text"
                  id="textarea"
                  :placeholder="placeholder"
                  v-model="notedata"></textarea>
        <div class="Submit">
          <button @click="sub()">提交</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Bus from '@/bus.js'
export default {
  name: 'fabulous',
  data () {
    return {
      that:window,
      initData: { like: 0, likeNum: 0,collect: 0, collectNum: 0 },
      userId: this.$store.state.userInfo.userId ? this.$store.state.userInfo.userId : (this.getQuery('localUserId') ? this.getQuery('localUserId') : localStorage.getItem('noLoginSid')),
      userName: this.$store.state.userInfo.trueName ? this.$store.state.userInfo.trueName : (this.getQuery('localUserId') ? this.getQuery('localUserId') : localStorage.getItem('wxud')),
      photo: this.$store.state.userInfo.photo ? this.$store.state.baseURL + `/cme-sso-app/showimg/${JSON.parse(this.$store.state.userInfo.photo)[0].id}` : "",
      creatUserId: {},
      isMedia: this.getQuery('isMedia'),
      shopping:0,
      messages:[],
      requiredMsgs:[],
      brush: this.getQuery('brush'),
      placeholder: '评论',
      notedata: '',
      reflex: this.$store.state.isOrNotXgwz ? true : false,
      isOverThreeLines:false,
      iconType:'likes',
      forwardShow:false,
      pinglunShow:false,
      centerShow:[],
      titleCont:this.ite&&this.ite.others&&this.ite.others[0].standardData?this.ite.others[0].standardData:'',
      content:[],//评论内容
      pLshowMore:false,//评论展开收起
      plnum:1,//评论点击更多次数，一次4条
      dznum:1,//点赞转发点击更多次数，一次4行
      dzHeight:0,//点赞转发收藏总高度
      pinglunShow:false
    }
  },
  props: {
    contentIds: String,
    blockId: String,
    standardJson:Array,
    title:String,
    contentWzUrl:String,
    ite:Object,
    ind:Number,
    zzblockId:String,
    blockData:Object,
    length:Number//父级页面是否选中组织身份、专项平台
  },
  mounted () {
    this.contentData();
    this.getShopping();
    Bus.$on('replayFalse',()=>{
      this.forwardShow = false;
      this.pinglunShow = false;
    })
    Bus.$on('clearDz',(data)=>{
      //隐藏其他点赞收藏，展示当前
      this.centerShow = [];
      this.pinglunShow = false;
      if(data.type == 'pinglun' && this.ite.contentId == data.contentId) return //当前组件的,点击评论量不隐藏当前评论框
      this.reflex = false;
    })
    Bus.$on('clearPl',(data)=>{
      //隐藏其他评论，展示当前
      this.reflex = false;
      if(this.ite.contentId != data){
        this.centerShow = [];
        this.pinglunShow = false;
      }
    })
  },
  watch:{
    'title'(newd,old){
      this.contentData();
    }
  },
  methods: {
    dzShow(){
      if(this.dzHeight > 16*4*this.dznum){
        //没有展示完
        this.dznum ++ 
      }else{
        this.dznum = 1
      }
    },
    pLShow(){
      if(this.content.length > 4*this.plnum){
        //没有展示完
        this.plnum ++ 
      }else{
        this.plnum = 1
      }
    },
    dialogue(ite,to){
      // if(this.$route.params.id == 'chat'){
        layer.open({
          type: 2,
          title: (to ? ite.toUserName : ite.userName),
          closeBtn: 1,
          area: ['100%', '100%'],
          content: this.$store.state.baseURL + '/aassid/tag/con/middleIndex?floorWinType=1&showHide=8&pfId='+ window.$pfId +'&contentId='+ this.contentIds +'&nowReceiveId='+ (to ? ite.toUserId : ite.userId) +'&userId=' + this.userId 
        })
      // }
    },
    retransmission(num){
      var name,url;
      // if(num){
      //   name = '重新转发';
      //   url = this.$store.state.baseURL + '/zciid-deliverable/api/issue/socialAnewIssue?anew=anew&pfId='+ window.$pfId +'&userId='+ this.userId +'&contentId=' + this.contentIds + '&contentName=' + this.titleCont;
      // }else{
        name = '直接转发';
        url = this.$store.state.baseURL + '/zciid-deliverable/grab/start/edit?id=' + this.contentIds + '&userId=' + this.userId + '&userName=' + this.userName + '&dataType=forward';
      // }
      layer.open({
        type: 2,
        title: name,
        closeBtn: 1,
        area: ['100%', '100%'],
        content: url
      })
    },
    pinglunChange(){
      if(!this.pinglunShow){
        //隐藏所有浮层
        Bus.$emit('replayFalse');
        this.pinglunShow = true;
        this.forwardShow = false;
      }else{
        this.pinglunShow = false;
      }
    },
    forwardShowOrNot(){
      if(!this.forwardShow){
        //隐藏所有浮层
        Bus.$emit('replayFalse');
        this.forwardShow = true;
        this.pinglunShow = false;
      }else{
        this.forwardShow = false;
      }
    },
    changeCenterShow(type){
      Bus.$emit('clearDz',{type:type,contentId:this.ite.contentId})
      if(type == 'pinglun'){
        this.iconType = '';
        this.centerShow = [];
        this.pinglunShow = true;
      }else if(this.initData[type].length > 0){
        this.iconType = type;
        this.centerShow = this.initData[type];
        this.pinglunShow = false;
        this.dznum = 1
        this.isOverThreeLines = false;
        this.$nextTick(()=>{
          this.checkLines()
        })
      }
    },
    checkLines() {
      //判断点赞评论是否超过4行
      if(this.$refs.textRef){
        const textElement = this.$refs.textRef;
        const lineRects = textElement.getClientRects();
        //记录点赞转发收藏高度
        this.dzHeight = lineRects[0].height;
        this.$nextTick(()=>{
          this.isOverThreeLines = lineRects[0].height > 64;
        })
      }
    },
    getShopping(){
      this.$http
        .get('/zciid-deliverable/api/abduction/getWzFloorButtonType.json', {
          floorFlowId: this.getQuery('floorflowId'),
          }).then(res=>{
            if(res.state == 1){
              this.shopping = parseInt(res.data);
            }
          })
    },
    contentData () {
      this.$http
        .get('/zciid-deliverable/interface/deliverables/allComment/list.json', {
          contentId: this.contentIds,
          userId: this.userId,
          userName: this.userName,
          isMedia:this.isMedia
        })
        .then(res => {
          if (res.state == 1) {
            this.initData = res.data;
            // this.centerShow = res.data.likes;
            this.content = res.data.commentTexts;
            this.$nextTick(()=>{
              this.checkLines()
            })
          }
        });
        if(this.getQuery('brush') == 2){
          this.creatUserId.pfPhoto = this.ite.photo;
          this.creatUserId.pfName = this.ite.userName;
          return;
        }
        var arr = ['main-products']
        
        if(this.getQuery('brush') == 1 && !this.length && !arr.includes(this.blockData.flowEnName || this.getQuery('flowEnName'))){
          this.creatUserId.pfPhoto = this.ite.userPhoto || this.ite.appPhoto;
          this.creatUserId.pfName = this.ite.appName;
          return;
        }
        var url,data;
        if(this.ite&&this.ite.contentDsfWzUrl){
          url = '/zciid-deliverable/api/abduction/getDsfDataByAppId.json';
          data = {appId : this.ite.appId};
        }else if(this.ite&&this.ite.communicationId){
          url = '/zciid-deliverable/api/showPlatform/content/getLiveStreamingDataById.json';
          data = {communicationId : this.ite.communicationId,zzBlockId:this.zzblockId};
        }else{
          url = '/zciid-deliverable/showPlatformStyle/flow/api/get/getContentByIdAndStandardId.json';
          data = {contentId: this.contentIds,isMedia:this.isMedia,zzBlockId:this.getQuery('zzBlockId')};
        }

      this.$http
        .get(url, data)
        .then(res => {
          if (res.state == 1) {
            this.creatUserId = res.data;
          }else{
            this.creatUserId = {};
          }
        });
    },
    //点赞
    changOption () {
      if (!parseInt(this.initData.like)) {
        //点赞
        this.$http
          .get('/zciid-deliverable/interface/deliverables/update/like.json', {
            contentId: this.contentIds,
            userId: this.userId,
            userName: this.userName,
            photo: this.photo,
            isMedia:this.isMedia
          })
          .then(res => {
            if (res.state == 1) {
              this.initData.like = 1;
              this.initData.likeNum = this.initData.likeNum + 1;
            }
          }).then(()=>{
            this.contentData();
          });;
      } else {
        //取消点赞
        this.$http
          .get('/zciid-deliverable/interface/deliverables/update/like.json', {
            contentId: this.contentIds,
            userId: this.userId,
            userName: this.userName,
            photo: this.photo,
            isMedia:this.isMedia
          })
          .then(res => {
            if (res.state == 1) {
              if (this.initData.likeNum == 0) {
                return
              } else {
                this.initData.like = 0;
                this.initData.likeNum = this.initData.likeNum - 1;
              }
            }
          }).then(()=>{
            this.contentData();
          });;
      }
    },
    //收藏
    changOptions (t) {
      if (!parseInt(this.initData.collect)) {
        //收藏
        this.$http
          .get('/zciid-deliverable/interface/deliverables/update/collect.json', {
            contentId: this.contentIds,
            userId: this.userId,
            userName: this.userName,
            photo: this.photo,
            isMedia:this.isMedia
          })
          .then(res => {
            if (res.state == 1) {
              this.initData.collect = 1;
              this.initData.collectNum = this.initData.collectNum + 1;
            }
          }).then(()=>{
            this.contentData();
          });;
      } else {
        //取消收藏
        this.$http
          .get('/zciid-deliverable/interface/deliverables/update/collect.json', {
            contentId: this.contentIds,
            userId: this.userId,
            userName: this.userName,
            photo: this.photo,
            isMedia:this.isMedia
          })
          .then(res => {
            if (res.state == 1) {
              if (this.initData.collectNum == 0) {
                return
              } else {
                this.initData.collect = 0;
                this.initData.collectNum = this.initData.collectNum - 1;
              }
            }
          }).then(()=>{
            this.contentData();
          });;
      }
    },
    //删除
    deletes (id) {
      this.$http
        .get('/zciid-deliverable/interface/deliverables/delete/comment.json', {
          id: id,
        })
        .then(res => {
          if (res.message == "评论删除成功") {
            this.contentData();
          }
        });
    },
    sub () {
      if (!this.notedata){
        this.$notify({
          title: '提示',
          message: '请评论后，再提交',
          type: 'warning',
          duration: 1000
        });
        return false;
      }
      if (this.placeholder.indexOf('评论') > -1) {
        this.$http
          .get('/zciid-deliverable/interface/deliverables/update/comment.json', {
            contentId: this.contentIds,
            userId: this.userId,
            userName: this.userName,
            photo: this.photo,
            texts: this.notedata
          })
          .then(res => {
            if (res.state == 1) {
              this.contentData();
              this.reflex = false;
              this.notedata = '';
              // var text = document.getElementsByClassName("line");
              // if(text){
              //   text[0].scrollIntoView({ behavior: "smooth" });
              // }
            }
          });
      } else {
        this.$http
          .get('/zciid-deliverable/interface/deliverables/update/comment.json', {
            contentId: this.contentIds,
            userId: this.userId,
            userName: this.userName,
            toUserId: this.content[this.newIndex].userId,
            toUserName: this.content[this.newIndex].userName,
            photo: this.photo,
            standardData: this.pic ? this.pic : '',
            texts: this.notedata
          })
          .then(res => {
            if (res.state == 1) {
              this.contentData();
              this.reflex = false;
              this.notedata = '';
            }
          });
      }
    },
    repeat(name){
      switch (name){
        case 'forward':{
          layer.open({
            type: 2,
            title: '转发给好友',
            closeBtn: 1,
            area: ['100%', '100%'],
            content: this.$store.state.baseURL + '/zciid-deliverable/interface/deliverables/transmit/user/list?pfId=' + (window.$pfId?window.$pfId:'') + '&userId=' + this.$store.state.userInfo.userId + '&id=' + this.contentIds + '&title=' + this.title + '&url=' + encodeURIComponent( this.getQuery('brush') ? (this.contentWzUrl ? this.contentWzUrl : this.ite.contentDsfWzUrl) : (window.location.origin+window.location.pathname + '?appId=' + this.getQuery('appId')+'&blockId='+this.blockId+'&dataType=1&contentId='+this.contentIds)) + '&appId=' + this.ite.appId + '&appName=' + this.ite.appName + '&time=' + Date.now()
          })
          break;
        }
        case 'Cart':{
          this.joinShopCart(this.contentIds,this.standardJson);
          break;
        }
        case 'shopping':{
          // if(this.cartIds){
          //   layer.open({
          //     type: 2,
          //     title: '结算',
          //     closeBtn: 1,
          //     area: ['100%', '100%'],
          //     content: this.$store.state.baseURL + '/oqmid-pay-tool-web/shop/cart/to-add-order?cartIds=' + this.cartIds
          //   })
          // }else{
            this.joinShopCart(this.contentIds,this.standardJson,'shopping');
          // }
        }
      }
    },
    dialogues(){
      layer.open({
        id: 'transpond',
        type: 2,
        title: '对话',
        fixed: true,
        maxmin: true,
        area: ['100%', '100%'],
        content: '/aassid/tag/con/middleIndex?floorWinType=1&pfId='+ window.$pfId +'&nowReceiveId='+ this.contentIds + (this.$store.state.userInfo.userId ? '' : ('&wxud=' + localStorage.getItem('wxud'))),
        close: function () {}
      })
    },
    //评论和回复
    reflexs (name, ind) {
      //点击评论
      if (!this.reflex && !name) {
        Bus.$emit('clearPl',this.ite.contentId)
        this.reflex = true;
        this.newIndex = -1;
      } else {
        //点击回复
        if (name) {
          if (!this.reflex) {
            Bus.$emit('clearPl',this.ite.contentId)
            this.reflex = true;
            this.newIndex = ind;
          } else {
            //评论框已显示,并且第二次点击是同一个
            if (ind == this.newIndex) {
              this.reflex = false;
            }
            this.newIndex = ind;
          }
        } else {
          //再次点击评论
          if (!(this.placeholder.indexOf('回复') > -1 && this.reflex)) {
            this.reflex = false;
          }
          this.newIndex = -1;
        }
      }
      if (this.$store.state.userInfo.trueName) {
        if (name && name.userName != this.$store.state.userInfo.trueName) {
          this.placeholder = '回复 ' + name.userName;
        } else {
          this.placeholder = '评论';
        }
      } else {
        if (name && name.userName != (this.getQuery('localUserId') ? this.getQuery('localUserId') : localStorage.getItem('wxud'))) {
          this.placeholder = '回复 ' + name.userName;
        } else {
          this.placeholder = '评论';
        }
      }

      setTimeout(() => {
        var text = document.getElementById("textarea");
        if (text) {
          this.autoTextarea(text);
          // text.scrollIntoView({ behavior: "smooth" });
        }
      })
    },
    longtext (str,num) {
      if (str && str.length > num) {
        str = str.substr(0, num) + "..."
      }
      return str;
    },
    //标签取值方法
    getStandardData (nameArr, type, nameData, allTagsJson) {
      const allTagsStandArr = allTagsJson;
      const sNames = (typeof nameArr == 'string') ? [nameArr] : nameArr;
      var filterStandArr = allTagsStandArr.filter((ite) => sNames.indexOf(ite.standardName) > -1);
      // var filterData = sNames.indexOf(allTagsStandArr.standardName) > -1 ? allTagsStandArr.standardData : nameData;
      var filterData = filterStandArr[0] ? filterStandArr[0].standardData : nameData;
      var message = '';
      var requiredMsg = '';
      switch (type) {
        case 'required':
          if (!filterData) {
            requiredMsg = `${sNames[0]}`;
          }
          break;
        case 'number':
          if (isNaN(filterData)) {
            message = `${sNames[0]}`;
          }
          break;
      }
      if (requiredMsg) {
        this.requiredMsgs.push(requiredMsg);
      }
      if (message) {
        this.messages.push(message);
      }
      return filterData;
    },
    //加入购物车 所需参数拼接
    joinShopCart (pId, allTagsJson,shopping) {
      this.messages = [];
      this.requiredMsgs = [];
      //产品名称
      var chanpinmingchen = allTagsJson.filter((tags) => tags.standardEnName && tags.standardEnName == 'appName').length ? allTagsJson.filter((tags) => tags.standardEnName && tags.standardEnName == 'appName')[0].standardData : this.getStandardData(['名称', '组织名称', '企业名称', '个人名称', '产品名称', '图片名称'], 'required', '', allTagsJson);
      //产品图片
      var chanpintupian = allTagsJson.filter((tags)=>tags.fileTypeDetail == 2&&tags.standardData).length  ? allTagsJson.filter((tags)=>tags.fileTypeDetail == 2&&tags.standardData)[0].standardData : '';
      //单价
      var price = allTagsJson.filter((tags) => tags.standardData && (tags.standardEnName == 'cpyxprice'||tags.standardEnName == 'xmjcprice'||tags.standardEnName == 'basicPrice'));
      var danjia = price.length ? (price ? price[0].standardData : '') : this.getStandardData(['', '基础价格', '产品基础标签', '产品价格', '价格', '基准价', '金额'], 'number', '', allTagsJson);
      //数量
      var shuliang = allTagsJson.filter((tags) => tags.standardEnName && tags.standardEnName == 'number').length ? allTagsJson.filter((tags) => tags.standardEnName && tags.standardEnName == 'number')[0].standardData : this.getStandardData('数量', 'number', '1', allTagsJson);
      //用户ID
      var userId = this.$store.state.userInfo.userId ? this.$store.state.userInfo.userId : '';
      //产品标识
      var productId = allTagsJson.filter((tags) => tags.standardEnName && tags.standardEnName == 'productMarking').length ? allTagsJson.filter((tags) => tags.standardEnName && tags.standardEnName == 'productMarking')[0].standardData : '';
      //资产交易价
      var assetsPrice = allTagsJson.filter((tags) => tags.standardEnName && tags.standardEnName == 'assetsPrice').length ? allTagsJson.filter((tags) => tags.standardEnName && tags.standardEnName == 'assetsPrice')[0].standardData : '';
      //资产单位
      var assetsUnit = allTagsJson.filter((tags) => tags.standardEnName && tags.standardEnName == 'assetsUnit').length ? allTagsJson.filter((tags) => tags.standardEnName && tags.standardEnName == 'assetsUnit')[0].standardData : '';
      //租赁交易价
      var periodicPrice = allTagsJson.filter((tags) => tags.standardEnName && tags.standardEnName == 'periodicPrice').length ? allTagsJson.filter((tags) => tags.standardEnName && tags.standardEnName == 'periodicPrice')[0].standardData : '';
      //租赁单位
      var periodicUnit = allTagsJson.filter((tags) => tags.standardEnName && tags.standardEnName == 'periodicUnit').length ? allTagsJson.filter((tags) => tags.standardEnName && tags.standardEnName == 'periodicUnit')[0].standardData : '';
      if ((this.requiredMsgs.length > 0 || !chanpintupian || !danjia)&& !assetsPrice && !periodicPrice) {
        this.$notify({
          title: '提示',
          message: `(产品名称或图片名称、产品图片、单价)为必填选项，请去补充标签，并生成，再进行此操作`,
          type: 'warning',
          duration: 5000
        });
        return;
      }

      if (this.messages.length > 0) {
        this.$notify({
          title: '提示',
          message: `${this.messages.join('、')}，的值不是数字类型，请输入阿拉伯数字`,
          type: 'warning',
          duration: 5000
        });
        return;
      }

      if (danjia == '面议') {
        this.$notify({
          title: '提示',
          message: '此产品不支持加入购物车',
          type: 'warning',
          duration: 5000
        });
        return;
      }
      if (!productId) {
        this.$notify({
          title: '提示',
          message: '该产品暂不能购买',
          type: 'warning',
        });
        return;
      }
      var productInfo = this.ite.pData;
      //数据资产类型
      var arrs = ['data-asset','organizational-assets','platform-assets','special-asset','window-asset'];
      var cart = {
        productName: chanpinmingchen,
        productImg: chanpintupian,
        prices: this.$store.state.memberLevel && productInfo[this.getMemberLevel(this.$store.state.memberLevel).memberLevel] && productInfo.memberEndTime ? productInfo[this.getMemberLevel(this.$store.state.memberLevel).memberLevel] : (assetsPrice ? assetsPrice : (periodicPrice ? periodicPrice : (productInfo.discountTypes ? productInfo.priceType : danjia))),
        activityType: this.$store.state.memberLevel && productInfo[this.getMemberLevel(this.$store.state.memberLevel).memberLevel] && productInfo.memberEndTime ? 'blankVip' : (productInfo.discountTypes ? productInfo.discountTypes : ''),
        buyNumber: shuliang,
        userId: userId ? userId : '',
        codes: userId ? '' : (this.getQuery('localUserId') ? this.getQuery('localUserId') : localStorage.getItem('wxud')),
        productId: arrs.includes(this.getQuery('flowEnName')) ? ('asset-' + pId) : (productId ? (productId + '-' + pId) : pId),
        wzAppId: this.getQuery('appId') ? this.getQuery('appId') : '',
        units: assetsPrice ? assetsUnit : (periodicPrice ? periodicUnit : '个'),
        dataType: assetsPrice ? 1 : (periodicPrice ? 2 : 0),
        merchantId:this.ite.appId,
        merchantName:this.ite.appName,
        payPfId:this.ite.pfId ? this.ite.pfId : '',
        detailsUrl:location.origin + '/uoqid?appId='+ this.ite.appId +'&blockId='+ this.ite.blockId +'&contentId='+ this.ite.contentId +'&dataType=' + (this.ite.sign ? this.ite.sign : 1),
        // detailsUrl:'',
        pfId:window.$pfId ? window.$pfId : '',
        types: (this.ite.pfId ? this.ite.pfId : '') == (window.$pfId ? window.$pfId : '') ? 1 : 2
      };
      if (assetsPrice && periodicPrice) {
        window.$chooseToCart = true;
        this.chooseToCart(assetsPrice, assetsUnit, periodicPrice, periodicUnit, JSON.stringify(cart).replace(/"/g, '&quot;'),pId,shopping);
        return;
      } else {
        window.$chooseToCart = false;
      }
      this.$http
        .post('/oqmid-pay-tool-web/shop/cart/save', { arrs: JSON.stringify(cart) }, 'a')
        .then(res => {
          if (res.state == 1) {
            const h = this.$createElement;
            this.$notify({
              title: '提示',
              dangerouslyUseHTMLString: true,
              type: 'success',
              duration: 3000,
              message: h('div', { class: 'personnel' }, [
                h('p', { class: 'isCreate' }, '加入购物车成功！'),
                h('button', {
                  class: 'personnel-btn', on: {
                    click: this.toOpen
                  }
                }, '购物车')
              ]),
            })
          }else{
            this.$notify({
              title: '提示',
              message: `该产品暂不支持购买`,
              type: 'warning',
              duration: 5000
            });
            return;
          }
          this.cartIds = res.data;
          if(shopping){
            layer.open({
              type: 2,
              title: '结算',
              closeBtn: 1,
              area: ['100%', '100%'],
              content: this.$store.state.baseURL + '/oqmid-pay-tool-web/shop/cart/to-add-order?cartIds=' + res.data
            })
          }
        });
    },
    toOpen(){
      this.$notify.closeAll();
      this.handleShopCart();
    }
  }
}
</script>
<style lang="scss" scoped>
.chat .fabulous .numbers:hover{
    color: #0c78cf;
  }
.fabulous {
  display: flex;
  justify-content: space-between;
  position: relative;
  margin-top: 7px;
  
  span {
    padding-left: 6px;
    color: #666;
    font-size: 12px;
  }
  .headImg {
    display: flex;
    align-items: center;
    img {
      width: 22px;
      height: 22px;
      border-radius: 11px;
      margin-right: 6px;
    }
    span {
      max-width: 48px;
      overflow: hidden;
      white-space: nowrap;
      padding-left: 0;
    }
  }
  .fabulous-right{
    cursor:pointer;
  }
  .clickFab {
    display: flex;
    align-items: center;
    position: relative;
    i{
      width:15px;
      height:16px;
    }
    .FloatingLayer{
      width: 110px;
      height: 78px;
      background-color: #fff;
      position: absolute;
      top: -96px;
      left: 50%;
      right: 50%;
      transform: translateX(-50%);
      z-index: 1000;
      -webkit-box-shadow: 0 2px 12px 0 #888888;
      box-shadow: 0 2px 12px 0 #888888;
      .suspend{
        padding: 13px 10px 0;
        line-height: 20px;
        &:hover{
          color: #0c78cf;
        }
      }
      &::after{
        content: "";
        border-top: 8px solid #fff;
        border-right: 8px solid transparent;
        border-bottom: none;
        border-left: 8px solid transparent;
        position: absolute;
        bottom: -8px;
        right: 50%;
        margin-right: -8px;
      }
    }
  }
  .clickFab img {
    width:15px;
    height:16px;
  }
  .clickFab:not(:first-child){
    margin-left:10px;
  }
  .clickFab:nth-child(2){
    margin-left:8px;
  }
  .clickFab.shopping i{
    background:url('../assets/image/images/submit_order.png') no-repeat center center;
  }
  .clickFab.shopping i:hover{
    background:url('../assets/image/images/submit_order_submit_order.png') no-repeat center center;
  }
  
  @media screen and (max-width: 640px) {
    .headImg{
      flex-grow: 1;
      overflow: hidden;
      span{
        max-width: 200px;
      }
    } 
  }
}
 .comment {
  margin-top: 10px;
  .pLmoreOrNot{
    margin-top: 5px;
    text-align: center;
    color: #666;
    cursor: pointer;
  }
}
.LikePeople{
  padding: 6px 8px 6px 28px;
  border-radius: 5px;
  .moreOrNot{
    margin-top: 5px;
    text-align: center;
    cursor: pointer;
  }
  span{
    color:#2f8eed;
  }
}
.LikePeople.likes{
  background: #f0f7ff url("../assets/image/images/fabulous_curr.png") 8px 8px/12px no-repeat ;
}
.LikePeople.collects{
  background: #f0f7ff url("../assets/image/images/Collection_curr.png") 8px 8px/12px no-repeat ;
}
.LikePeople.forwards{
  background: #f0f7ff url("../assets/image/images/forward_small.png") 8px 8px/12px no-repeat ;
}
.LikePeople.downloads{
  background: #f0f7ff url("../assets/image/images/download_small.png") 8px 8px/12px no-repeat ;
}
.LikePeople .people{
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 4;
  padding-bottom: 2px;
}

.LikePeople span.name{
  font-size:12px;
  padding: 0 4px 0 0;
  cursor: pointer;
}
.chat .LikePeople span.name:hover{
  text-decoration: underline;
  text-underline-position: under;
}
// .LikePeople span[title]:hover:after{
//   content: attr(title);
//   color: #fff;
//   padding: 4px 8px;
//   position: absolute;
//   left: 0;
//   top: -160%;
//   z-index: 20;
//   background-color: rgba(37, 39, 42, .85);
// }

.comment .line {
  margin-top: 6px;
  display: flex;
  justify-content: space-between;
}
.comment .line .line-l .rep {
  font-size: 12px;
  color: #666666;
}
.comment .line .line-r {
  display: flex;
  flex-direction: row-reverse;
  width: 70px;
}
.comment .line .line-l {
  width: calc(100% - 28px);
  color: #666666;
}
.comment .line .reply {
  display: flex;
  height: 14px;
  // width: 49px;
  font-size: 13px;
  line-height: 14px;
  color: #666666;
  cursor: pointer;
  // margin: 4px 0 0 21px;
  margin-left: 21px;
}
.comment .line .delete {
  height: 14px;
  // width: 49px;
  line-height: 14px;
  font-size: 13px;
  // margin-top: 4px;
  margin-left: 10px;
  color: #666666;
}
.comment .line .delete > div {
  display: flex;
  cursor: pointer;
}
.comment .line .reply span,
.delete span {
  margin-left: 6px;
}
.comment .name {
  font-size: 12px;
  cursor: pointer;
}
.chat .comment .name:hover {
  color: #0c78cf;
  text-decoration: underline;
  text-underline-position: under
}
.comment .content {
  font-size: 12px;
  line-height: 14px;
}
.comment .reflex {
  margin: 12px 0 0;
  border: 1px solid #ddd;
  display: flex;
  flex-direction: column;
}
.comment .reflex textarea {
  border: none;
  resize: none;
  overflow-y: hidden;
  font-size: 14px;
  line-height: 24px;
  height: 45px;
}
.personnel {
  width: 262px;
  display: flex;
  justify-content: space-between;
}
.personnel-btn {
  cursor: pointer;
  border-radius: 3px;
  color: #fff;
  border: 1px solid #2f8eed;
  background-color: #2f8eed;
}
.comment .reflex .Submit button {
  float: right;
  width: 100px;
  height: 30px;
  margin: 8px;
  color: #ffffff;
  background-color: #0d78cf;
  border-radius: 3px;
}

</style>
<style lang="scss">
  .fabulous-right{
    .shopping.el-cascader-menu{
      position:absolute;
      bottom: 45px;
      left: 45%;
      right: 50%;
      transform: translateX(-50%);
      background:#fff;
      width:200px;
      height:200px;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.5);
      .el-cascader-menu__wrap.el-scrollbar__wrap{
        overflow-y: hidden;
      }
      .el-cascader-menu__wrap{
        height: 200px !important;
      }
      .triangle {
        position: absolute;
        bottom: -4px;
        left: 93%;
        margin-left: -2px;
        width: 0;
        height: 0;
        border-right: 4px solid transparent;
        border-left: 4px solid transparent;
        border-top: 4px solid #fff;
      }
    }
    .shopping .shopping.el-cascader-menu{
      left: 55%;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/fabulous.vue